<template>
  <vue-dropzone
    :id="id"
    ref="fileDropzone"
    :options="options"
    use-custom-slot
    class="file-dropzone"
    @vdropzone-files-added="filesAdded"
  >
    <div class="dropzone-inner-content">
      <slot />
    </div>
  </vue-dropzone>
</template>

<script>
import vueDropzone from 'vue2-dropzone';

export default {
  name: 'FileDropzone',

  props: {
    id: {
      type: String,
      required: true,
    },

    options: {
      type: Object,
    },
  },

  methods: {
    filesAdded(files) {
      this.$emit('files-added', files);
    },
  },

  components: {
    vueDropzone,
  },
};
</script>

<style lang="scss" scoped>
.file-dropzone {
  position: relative;

  &::before,
  .dropzone-inner-content {
    transition: opacity 0.1s ease;
  }

  &::before {
    content: 'Subir ficheros';
    color: #6ebdf6;
    font-size: 22px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    background: rgba(240, 240, 240, 0.9);
    border: 3px dashed #6ebdf6;
    opacity: 0;
  }

  .dropzone-inner-content {
    position: relative;
    z-index: 2;
  }

  &.dz-drag-hover {
    .dropzone-inner-content {
      opacity: 0;
    }

    &::before {
      opacity: 1;
    }
  }

  /deep/ > *:not(.dz-message) {
    display: none;
  }
}
</style>
